import { inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticationService, ToastService } from '../services';
import { Observable, map, take } from 'rxjs';

export const canActivate = (
  activatedrouter: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | boolean
  | UrlTree
  | Promise<boolean | UrlTree>
  | Observable<boolean | UrlTree> => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const toast = inject(ToastService);
  return authenticationService.currentUser.pipe(
    take(1),
    map((user) => {
      // A saved user alone isn't enough — every protected page needs a
      // token too, otherwise its API calls would fail with 401.
      const loggedIn = !!user && !!localStorage.getItem('access_token');

      if (loggedIn) {
        return true;
      } else {
        const returnUrl = state.url;

        // 🔁 Define redirection logic based on return URL
        let redirectUrl = '/auth';

        // ✅ System admin login route match
        const systemAdminPaths = [
          '/org-management',
          '/org-dashboard'
        ];

        // Redirect to client login if returnUrl includes admin-facing routes
        const clientAdminPaths = [
          '/candidate-dashboard',
          '/user-management',
          '/hiring',
          '/job-posting',
          '/exam-management',
          '/admin-dashboard',
          '/employee-dashboard',
        ];

        // Redirect to candidate login if returnUrl includes candidate-facing routes
        const candidatePaths = [
          '/start-exam',
          '/exam-portal',
          '/candidate-assesment',
          '/start-interview',
          '/ai-interview',
          '/acceptorreject-offer',
        ];

        if (systemAdminPaths.some(path => returnUrl.startsWith(path))) {
          redirectUrl = '/auth/sign-in';
        } else if (clientAdminPaths.some(path => returnUrl.startsWith(path))) {
          redirectUrl = '/auth/login';
        } else if (candidatePaths.some(path => returnUrl.startsWith(path))) {
          redirectUrl = '/auth/sign-in';
        }

        toast.showError('Kindly sign in!');
        return router.createUrlTree([redirectUrl], {
          queryParams: { returnUrl },
        });
      }
    })
  );
};

export const canActivateChild = (
  activatedrouter: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return canActivate(activatedrouter, state);
};
